<template>
	<div class="My_pop _popRight _popdetails" id="POP-CAdetails-1" style="display: block;">
		<!-- POP -->
		<div class="pop_right " style="right: 0px;" v-loading="loadingMask">
			<!-- pop_right -->
			<ul class="pop_right_header2">
				<li>
					<h2>认证延期</h2>
				</li>
				<li>
					<btn class="pop_right_close2" name="pop-details-close" @click="closeFloat"></btn>
				</li>
			</ul>
			<div class="pop_right_main">
				<!-- main -->
				<ul class="form_list">
					<template v-if="bandingform.type==''">
						<li v-if="bandingform.ipiddate">
							<h4>IP验证</h4>
							<div class="input_out">
								<div class="input_inner">
									<div class="input_box"><input type="text" class="s_input"
											:value="'有效期至：'+bandingform.ipiddate" readonly="true"></div>
								</div>
								<div style="width: 200px;">IP段内登录自动延期</div style="width: 200px;">
							</div>
						</li>
						<li v-if="bandingform.wordiddate">
							<h4>单位邮箱</h4>
							<div class="input_out">
								<div class="input_inner">
									<div class="input_box"><input type="text" class="s_input"
											:value="'有效期至：'+bandingform.wordiddate" readonly="true"></div>
								</div>
								<btn class="btn-edit" @click="bandingform.type=1">延期</btn>
							</div>
						</li>
						<li v-if="bandingform.compiddate">
							<h4>管理员邮箱</h4>
							<div class="input_out">
								<div class="input_inner">
									<div class="input_box"><input type="text" class="s_input"
											:value="'有效期至：'+bandingform.compiddate" readonly="true"></div>
								</div>
								<btn class="btn-edit" @click="bandingform.type=2">延期</btn>
							</div>
						</li>
					</template>
					
						<!-- <li>
							<div class="">
								<ul class="mul-choice-list single">
									<li @click="bandingform.type=1">
										<check class="cei-icon"
											v-bind:class="bandingform.type==1?'s-checked':'s-checkbox'"></check>工作邮箱验证
									</li>
									<li @click="bandingform.type=2">
										<check class="cei-icon"
											v-bind:class="bandingform.type==2?'s-checked':'s-checkbox'"></check>管理员邮箱验证
									</li>
								</ul>
							</div>
						</li> -->
						<template v-if="bandingform.type==1">
							<li>
								填写工作邮箱
							</li>
							<li>
								<h4>工作邮箱</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="workemail.email"
												placeholder="请输入工作邮箱">
										</div>
									</div>
								</div>
							</li>
						</template>
						<template v-else-if="bandingform.type==2">
							<li>
								填写认证申请表
							</li>
							<li>
								<h4>姓名</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.name" placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>部门</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.department"
												placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>手机</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.phone" placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>座机</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.tel" placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>职位</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.job" placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>邮箱</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.email" placeholder="">
										</div>
									</div>
								</div>
							</li>
							<li>
								<h4>备注</h4>
								<div class="input_out">
									<div class="input_inner">
										<div class="input_box">
											<input type="text" class="s_input" v-model="compemail.note" placeholder="">
										</div>
									</div>
								</div>
							</li>
						</template>

				</ul>


			</div><!-- /main -->

			<div v-if="bandingform.type==1" class="pop_right_footer2">
				<btn class="s_btn_cancel" @click="bandingform.type=''">取消</btn>
				<btn class="s_btn" @click="workemailSubmit()">确定</btn>
			</div>
			<div v-else-if="bandingform.type==2" class="pop_right_footer2">
				<btn class="s_btn_cancel" @click="bandingform.type=''">取消</btn>
				<btn class="s_btn" @click="compemailSubmit()">确定</btn>
			</div>

		</div><!-- /pop_right -->
		<div class="pop_bg" style="display: block;" @click="closeFloat"></div>
	</div><!-- /POP -->
</template>

<script>
	export default {
		data() {
			return {
				loadingMask: false,
				bandingform: {
					type: '',
					bdjt:'',
					bdjtdate:'',
					ipid:'',
					ipiddate:'',
					wordid:'',
					wordiddate:'',
					compid:'',
					compiddate:'',
				},
				workemail: {
					email: ''
				},
				compemail: {
					name: '',
					department: '',
					phone: '',
					tel: '',
					job: '',
					email: '',
					note: ''
				},
				isorg: false,
				isipcan: false,
				iscanuwork: false, // personal mail
				iscancomwork: false, // company one
				orgbtp: -1, // 0 ip 1 umail personal 1 com one pubmail
				workidemailVisiable: false,
				compidemailVisiable: false,
			}
		},
		props: [
			'userinfo'
		],
		mounted: function() {
			this.initFunc();
		},
		methods: {
			initFunc: function() {
				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/orglong',
						responseType: 'json',
						params: {
							code : 123
						},
					})
					.then(function(response) {
						var result=JSON.parse(response.data.data.data);
						if (result.isSuccess){
							if(result.lst.n1!=null){
								_this.bandingform.ipiddate=result.lst.n1.dt;
							}
							if(result.lst.n3!=null){
								_this.bandingform.wordiddate=result.lst.n3.dt;
							}
							if(result.lst.n2!=null){
								_this.bandingform.compiddate=result.lst.n2.dt;
							}
							
						}
						
						
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});
			},
			workemailSubmit: function() {
				if (!this.workemail.email) {
					this.$message({
						message: '请填写邮箱',
						type: 'warning'
					});
					return false;
				} else {
					var regemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if (!regemail.test(this.workemail.email)) {
						this.$message({
							message: '请正确填写邮箱',
							type: 'warning'
						});
						return false;
					}
				}

				var online = this.onlineType();

				let _this = this;
				_this.loadingMask = true;
				this.$http({
						method: 'post',
						url: 'UserInfo/UMailBind41',
						responseType: 'json',
						params: {
							m: this.workemail.email,
							onlineType: online
						},
					})
					.then(function(response) {
						var text = response.data;
						if (text == "0" || text == "") {
							_this.$alert('邮件已发送，请到邮箱激活验证！', '成功', {
								confirmButtonText: '确定',
							});

							_this.$track([
								['pagetype', '工作邮箱延期集团账号']
							]);
							
							_this.closeFloat();

						} else if (text == "1") {
							_this.$alert('邮件发送失败！', '失败', {
								confirmButtonText: '确定',
							});
						} else if (text == "4") {
							_this.$alert('该邮箱已经进行了集团验证，请更换邮箱！有问题请联系客服。电话：010-68140800、68140808， qq交流群：767104678。',
								'失败', {
									confirmButtonText: '确定',
								});
						} else if (text == "3") {
							_this.$alert(
								'请输入单位统一后缀的个人邮箱，如中经网单位员工输入后缀为：@cei.cn的单位邮箱方可进行验证！有问题请联系客服。电话：010-68140800、68140808， qq交流群：767104678。',
								'失败', {
									confirmButtonText: '确定',
								});
						} else {
							var msg = decodeURIComponent(text);
							_this.$alert(msg, '失败', {
								confirmButtonText: '确定',
							});
						}
						_this.loadingMask = false;
					})
					.catch(function(error) {
						_this.loadingMask = false;
						console.log(error);
					});

			},
			compemailSubmit: function() {
				if (!this.compemail.name &&
					!this.compemail.department &&
					!this.compemail.phone &&
					!this.compemail.tel &&
					!this.compemail.job &&
					!this.compemail.email &&
					!this.compemail.note) {
					this.$message({
						message: '请按管理员要求填写，如有疑问请与单位管理员联系！',
						type: 'warning'
					});
					return false;
				} else if (this.compemail.phone) {
					var regmobile = /^(0|86|17951)?(13[0-9]|15[012356789]|17[01678]|18[0-9]|14[57])[0-9]{8}$/;
					if (!regmobile.test(this.compemail.phone)) {
						this.$message({
							message: '请填写正确的手机号码',
							type: 'warning'
						});
						return false;
					}
				} else if (this.compemail.email) {
					var regemail = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
					if (!regemail.test(this.compemail.email)) {
						this.$message({
							message: '请正确填写邮箱',
							type: 'warning'
						});
						return false;
					}
				}
				
				let _this = this;
				_this.loadingMask = true;
				this.$prompt('请输入管理员邮箱', '管理员邮箱验证---管理员邮箱', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
					inputErrorMessage: '邮箱格式不正确'
				}).then(function(response) {
					var online = _this.onlineType();
					_this.$http({
							method: 'post',
							url: 'UserInfo/PubMailBind42',
							responseType: 'json',
							params: {
								CoPubMail : response.value,
								vipname : _this.compemail.name,
								vipdepart : _this.compemail.department,
								vipmobile : _this.compemail.phone,
								vipduty : _this.compemail.job,
								vipemail : _this.compemail.email,
								vipnote : _this.compemail.note,
								unitnum : _this.compemail.tel,
								onlineType : online
							},
						})
						.then(function(response) {
							var text = response.data.data.data
							if (text == "0") {
								_this.$alert('邮件已发送，请等待管理员验证！', '成功', {
									confirmButtonText: '确定',
								});
					
								_this.$track([
									['pagetype', '管理员邮箱验证绑定集团']
								]);
								
								_this.closeFloat();
					
							} else if (text == "1") {
								_this.$alert('邮件发送失败！', '失败', {
									confirmButtonText: '确定',
								});
							} else if (text == "3") {
								_this.$alert(
									'公共邮箱输入不正确，请重新输入！',
									'失败', {
										confirmButtonText: '确定',
									});
							} else {
								var msg = decodeURIComponent(text);
								_this.$alert(msg, '失败', {
									confirmButtonText: '确定',
								});
							}
							_this.loadingMask = false;
						})
						.catch(function(error) {
							_this.loadingMask = false;
							console.log(error);
						});
					
				}).catch(function(error) {
					_this.loadingMask = false;
					console.log(error);
				});

			},
			closeFloat: function() {
				this.$emit('closefloat');
			},
			onlineType: function() {
				var sUserAgent = navigator.userAgent.toLowerCase();
				var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
				var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
				var bIsMidp = sUserAgent.match(/midp/i) == "midp";
				var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
				var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
				var bIsAndroid = sUserAgent.match(/android/i) == "android";
				var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
				var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
				// document.writeln("您的浏览设备为：");
				if (bIsUc7 || bIsUc) {
					return 1; //1网页 2手机 3pad 4 终端
				} else if (bIsIphoneOs || bIsMidp || bIsAndroid || bIsWM) {
					return 2;
				} else if (bIsIpad) {
					return 3;
				} else if (bIsCE || bIsWM) {
					return 4;
				} else {
					return 0;
				}
			}
		},
	}
</script>

<style>
</style>
